import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';
import InputDate from '../../../../../../../../components/NovoSistema/InputDate';
import InputCheckBox from '../../../../../../../../components/NovoSistema/InputCheckBox';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import InputText from '../../../../../../../../components/NovoSistema/InputText';

export default function InventarioFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <InputDate title="Data do Estoque" id="DataDoEstoque" widthPercentage="20%" />
            <DoubleInput title="Produto" id="Produto" widthPercentage="70%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Grupo Inicial" id="GrupoInicial" widthPercentage="45%" />
            <DoubleInput title="Grupo Final" id="GrupoFinal" widthPercentage="45%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Tipo de Produto"
              id="TipoDeProduto"
              optionsArray={[
                '',
                'Mercadoria para revender',
                'Matéria Prima',
                'Embalagem',
                'Produto em processo',
                'Produto acabado',
                'Subproduto',
                'Produto intermediário',
                'Material de uso e consumo',
                'Ativo Imobilizado',
                'Outros insumos',
                'Outras',
              ]}
              widthPercentage="20%"
            />
            <InputCheckBox title="Imprimir produtos com saldo zerado" id="ImprimirProdutosComSaldoZerado" />
            <InputCheckBox title="Imprimir produtos com saldo negativo" id="ImprimirProdutosComSaldoNegativo" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Tipo"
              id="Tipo"
              optionsArray={['Destacar Imposto', 'Padrão']}
              widthPercentage="20%"
            />
            <InputCheckBox title="Zerar produtos com saldo negativo" id="ZerarProdutosComSaldoNegativo" />
            <InputCheckBox title="Imprimir Código do Produto" id="ImprimirCodigoDoProduto" />
            <InputCheckBox
              title="Imprimir Termo de Abertura e Encerramento"
              id="ImprimirTermoDeAberturaEEncerramento"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Data de Abertura" id="DataDeAbertura" widthPercentage="30%" disabled={true} />
            <InputText title="Data de Encerramento" id="DataDeEncerramento" widthPercentage="30%" disabled={true} />
            <InputText title="Número do Livro" id="NumeroDoLivro" widthPercentage="30%" disabled={true} />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
    </div>
  );
}
